import {
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { IWizardExportPageComponent } from '../../models/config.model';

@Component({
  selector: 'content-page-wrapper',
  templateUrl: './content-page-wrapper.component.html',
  styleUrls: ['./content-page-wrapper.component.scss'],
  standalone: false,
})
export class ContentPageWrapperComponent implements OnInit {
  @Input() component: Type<unknown>;
  @Input() transferObject: object;
  @Output() componentInstantiated = new EventEmitter<IWizardExportPageComponent>();
  @ViewChild('container', { static: true, read: ViewContainerRef })
  private contentPageContainer: ViewContainerRef | undefined;

  constructor(private resolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.loadContent();
  }

  private loadContent(): void {
    const factory = this.resolver.resolveComponentFactory(this.component);
    const componentRef = this.contentPageContainer?.createComponent(factory);
    const instance = componentRef?.instance as IWizardExportPageComponent;
    instance.transferObject = this.transferObject;
    this.componentInstantiated.emit(instance);
  }
}
